<template>
  <div class="inboxes" v-loading="loading">
    <ul v-if="inboxes.list && inboxes.list.length > 0">
      <li v-for="inbox in inboxes.list" :key="inbox.id.numberStr" class="inbox">
        <strong>{{ inbox.name }}</strong>&nbsp;
        <inbox :inbox="inbox.id.numberStr" :team="team" :path="path"/>
      </li>
    </ul>
    <span v-else>--</span>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Inbox from '@/components/customers/Inbox'
export default {
  props: {
    team: {
      type: String,
      default: ''
    },
    path: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      loading: false,
      inboxes: [],
      limit: 1000,
      offset: 0
    }
  },
  computed: {
    ...mapGetters([
      'domainsPath'
    ])
  },
  methods: {
    ...mapActions([
      'handleRequest'
    ]),
    toggleLoading () {
      this.loading = !this.loading
    },
    getData () {
      const { limit, offset, path } = this
      this.toggleLoading()
      this.handleRequest({
        name: path,
        action: 'getAll',
        data: {
          query: {
            limit,
            offset
          }
        }
      }).then(inboxes => {
        this.inboxes = inboxes
      }).finally(this.toggleLoading)
    }
  },
  created () {
    this.getData()
  },
  components: {
    Inbox
  }
}
</script>

<style lang="css">
  .inboxes > ul {
    margin: 0;
    padding: 0;
  }
  .inboxes {
    margin-top: 10px;
  }
  .inboxes ul ul li {
    margin: 8px;
  }
  .inboxes ul ol li {
    margin: 2px 8px;
  }
  .inbox {
    padding: 10px 16px;
    list-style: none;
    margin: 0;
  }
  .inbox:nth-of-type(odd) {
    background: #f5f5f5;
  }
  .inbox:nth-of-type(even) {
    background: #EEEEEE;
  }
  .inbox span.main {
    color: #3f51b5
  }
  .inbox span.required {
    color: #009688;
  }
  .inbox span.excluded {
    color: #f44336;
  }
</style>
